<div class="row justify-content-center tabla">
    <div class="col-md-8 tab">
        <ul class="nav nav-tabs justify-content-center">
            <li class="nav-item active">
                <a class="nav-link active" data-toggle="tab" href="#errores">Arbol Ast</a>
            </li>
        </ul>
    </div>
    <img src="https://media.gettyimages.com/photos/artificial-ingelligence-cpu-empty-landscape-picture-id1132483126?s=2048x2048">
</div>


<!-- <script src="https://d3js.org/d3.v3.min.js"></script>
<script src="https://vanya.jp.net/vtree/dist/vtree.js"></script>
<script>
  window.onload = () => {
    var json = `{"mensaje":1}`;
    var vt = new VTree(astDiv);
    var reader = new VTree.reader.Object();
    var data = reader.read(JSON.parse(json));
    vt.data(data).update();
  };
</script>
<div id="astDiv"></div> -->